/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorMynaHomeWebTypename = "PharmacyCounselorMynaHomeWeb" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorMynaHomeWeb
 */
export interface PharmacyCounselorMynaHomeWeb {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorMynaHomeWeb
   */
  digitalPrescriptionStatus?: PharmacyCounselorMynaHomeWebDigitalPrescriptionStatusEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorMynaHomeWeb
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorMynaHomeWebDigitalPrescriptionStatusEnum {
  Unavailable = "unavailable",
  Submitted = "submitted",
  Incomplete = "incomplete",
  None = "none",
}

export function PharmacyCounselorMynaHomeWebFromJSON(json: any): PharmacyCounselorMynaHomeWeb {
  return PharmacyCounselorMynaHomeWebFromJSONTyped(json, false);
}

export function PharmacyCounselorMynaHomeWebFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorMynaHomeWeb {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorMynaHomeWebTypename,

    digitalPrescriptionStatus: !exists(json, "digital_prescription_status")
      ? undefined
      : json["digital_prescription_status"],
  };
}

export function PharmacyCounselorMynaHomeWebToJSON(object?: PharmacyCounselorMynaHomeWeb | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    digital_prescription_status: value.digitalPrescriptionStatus,
  };
}
